import React from "react";

const useAuthConsultantToken = () => {
  const consultantToken = localStorage.getItem("consultant.token") || null;
  return { consultantToken };
};

export default useAuthConsultantToken;
